import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	HostBinding,
	Input,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CoreState, Jurisdiction, JurisdictionSelector, RealityCheckData } from "@obg/ngx.core";
import { TranslationService } from "@obg/ngx.core.content";
import { CurrencyService } from "@obg/ngx.global";
import { ignoreNil } from "@obg/rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-reality-check-container",
	templateUrl: "./reality-check-info.container.html",
	styleUrls: ["./reality-check-info.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class RealityCheckContainer implements AfterViewInit {
	@HostBinding("class.obg-reality-check") hostCssClass = true;

	@ViewChild("content")
	content: ElementRef | undefined;

	@Input() set data(value: RealityCheckData) {
		const { totalBets = 0, totalWins = 0, netWinning = 0, elapsedMinutes } = value;
		this.netWinning = this.currency.format(netWinning);
		this.totalBets = this.currency.format(totalBets);
		this.totalWins = this.currency.format(totalWins);
		this.realityCheckLoggedIn = this.translate.getByKey("reality-check.loggedin", { minutes: elapsedMinutes });
	}

	showTotalBets$ = this.store.pipe(
		select(JurisdictionSelector.get),
		ignoreNil(),
		map((jurisdiction) => jurisdiction !== Jurisdiction.Georgia)
	);

	realityCheckLoggedIn: string | undefined;
	totalBets: string | null | undefined;
	totalWins: string | null | undefined;
	netWinning: string | null | undefined;
	hasOverflow: boolean | undefined;

	constructor(
		private store: Store<CoreState>,
		private translate: TranslationService,
		private currency: CurrencyService,
		private changeDetector: ChangeDetectorRef
	) {}
	ngAfterViewInit(): void {
		const element = this.content?.nativeElement;
		if (!element) {
			return;
		}

		const { scrollHeight, offsetHeight } = element;
		this.hasOverflow = scrollHeight !== undefined && offsetHeight !== undefined && scrollHeight > offsetHeight;
		this.changeDetector.detectChanges();
	}
}
